module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig1",
      "src": "images/fig_1.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("W")]), _vm._v("hile relaxing after a rigorous day at work, I was watching Billy Graham on television as he preached to a crowded stadium. As a new Christian, I was fascinated to see how God was once again using this dynamic evangelist.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Suddenly the phone rang. It was a former high school classmate who wanted to see if we could meet that night to continue a conversation we had started a few days earlier. He was on a spiritual journey and looking for help with some questions. I knew I should jump at the opportunity but, honestly, I was intimidated. He was one of the smartest people I knew, and I didn’t feel up to the task.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("How can I get out of this?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That was the question swirling through my mind as I stalled on the phone, trying to think of an excuse not to get together.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("I’m really tired after a stressful day,")]), _vm._v(" I told myself. "), _c('i', [_vm._v("Besides, I’m watching one of the greatest evangelists in the world—so I’m getting important training that will help me be more prepared the next time around!")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“You are the salt of the earth,” Jesus declared in Matthew 5:13. I may have been salt, but at that moment I was firmly stuck inside the saltshaker.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thankfully, the Holy Spirit knew how to shake me free that night—and before I’d finished rationalizing why I should say no to my friend, I heard myself telling him I’d be happy to get together. By the time the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("evening was over, by God’s grace, my friend had prayed to receive the forgiveness and leadership of Christ.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thankfully, the Holy Spirit knows how to shake you free to be used by him as well. In fact, the book you’re holding is one of God’s special tools for nudging reluctant believers like us out of our comfort zones and into places where we can really make a spiritual difference.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Out of the Saltshaker and Into the World")]), _vm._v(" is a classic—a book that new generations need to discover in order to benefit from its timeless message of hope and new life. What makes it so special? Adjectives that come to mind include "), _c('i', [_vm._v("winsomeness, optimism, authenticity, enthusiasm")]), _vm._v("—even "), _c('i', [_vm._v("effervescence")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Becky Pippert sparkles with evangelistic expectancy. I think that’s because she’s a true believer in the life-changing power of the gospel. She has seen it work, first in her own life and then in countless other lives she has touched.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Many Christians think the gospel is potentially powerful. But Becky has been party to too many spiritual transformations to believe it "), _c('i', [_vm._v("might")]), _vm._v(" have an impact—she "), _c('i', [_vm._v("expects")]), _vm._v(" it! For her, Romans 1:16 is no flowery ideal; it’s a regular reality. That’s why she is “not ashamed of this Good News about Christ”—she knows that “it is the power of God at work, saving everyone who believes” (NLT).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So if you’ve started to despair about the spiritual state of people around you, or if you’ve begun to believe the Christian faith has seen its better days, then it’s time to pour a cup of coffee, settle into your favorite chair and crack open this timeless treasure. As you read the episodes of Becky’s real-life outreach adventure and as you hear about how lives have been changed through her efforts to share the love and truth of Jesus, you’ll feel an increasing sense of anticipation for how God wants to work through your life in exciting new ways.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Because the good news is "), _c('i', [_vm._v("still")]), _vm._v(" the power of God at work, saving everyone who believes—and Becky will show you how that power can flow through you.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0